/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */

import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";
import { UseMutateFunction } from "@tanstack/react-query";
import ProjectPhasingV2 from "./assumption-tabs/ProjectPhasingV2";
import EscalationRate from "./assumption-tabs/EscalationRate";

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;


	return (
		<Box
			role="tabpanel"
			className='tabPanelBox'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box className='tabBox' sx={{ p: 3 }}>
					{children}
				</Box>
			)}
		</Box>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

type Props = {
	setTabIndex: React.Dispatch<React.SetStateAction<number>>,
	scenarioID: string,
	runModel: UseMutateFunction
};

export default function AssumptionEditor(props: Props) {
	const { setTabIndex, scenarioID, runModel } = props;
	const [subTabIndex, setSubTabIndex] = React.useState(0);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setSubTabIndex(newValue);
	};

	function handleUpdateTab(index: number) {
		runModel();
		setTabIndex(index);
	}

	return <Stack spacing={2}>
		<Box className='tabSelectorBox'>
			<Tabs value={subTabIndex} onChange={handleChange} indicatorColor="secondary"
				textColor="inherit"
			>
				<Tab label="Project Phase" {...a11yProps(0)} />
               {/* <Tab label="Escalation rate" {...a11yProps(1)} /> */}
			</Tabs>
		</Box>
		<TabPanel value={subTabIndex} index={0}>
			<ProjectPhasingV2 scenarioID={scenarioID} onTabChange={handleUpdateTab} />
		</TabPanel>
		<TabPanel value={subTabIndex} index={1}>
			<EscalationRate onTabChange={handleUpdateTab} scenarioID={scenarioID} />
		</TabPanel>
	</Stack>;
}
